import {Injectable} from '@angular/core';
import {formatNumber, NumberFormat} from "libphonenumber-js";
import {CountryCode} from "libphonenumber-js/max";

@Injectable()
export class PhoneFormatterService {

  countryCode: CountryCode = 'RU';
  numberFormat: NumberFormat = 'E.164';

  constructor() { }

  formatPhoneNumber(phone: string): string {
    if(phone.startsWith("7")){
      phone = phone.substring(1);
    }
    /*E.164 возвращает номер в формате +7..., нам нужно 7..., поэтому берется подстрока*/
    let formattedNumber = formatNumber(phone, this.countryCode, this.numberFormat).substring(1);
    if(formattedNumber.length != 11 && formattedNumber.length != 0){
      console.log("Number", phone);
      console.log("Phone number is too long", formattedNumber);
      throw new Error(phone);
    }
    return formattedNumber;
  }

  private parsePhoneList(phones: string, delimiter: string = ','): Array<string> {
    let phonesArray: Array<string>;
    phonesArray = phones.split(delimiter);
      return phonesArray.map(phone => this.formatPhoneNumber(phone));
  }

  formatPhoneList(phones: string, delimiter: string = ','): string[]{
    phones = phones.replace(/(?:")/g, '');
    phones = phones.replace(/(?:\r\n|\r|\n)/g, ",");
    phones = phones.replace("\\t", ",");
    phones = phones.replace(";", ",");
    console.log("PHONES ARE", phones);
    const cleanedPhones = this.cleanCSV(phones);
    return this.parsePhoneList(cleanedPhones, delimiter).filter(p => p != "");
  }

  cleanCSV(value: string): string {
    return (value || '').split(',').filter(Boolean).filter(function(item, index, all) {
      return (index === all.indexOf(item));
    }).join(",");
  }


}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_service/phone-formatter-service/phone-formatter.service.ts